export default class BaseLiveTVMessage {
    constructor(parentContainer, template) {
        this.parentContainer = parentContainer;
        this.template = template;

        this.onCtaClickedCallback = null;

        this.me = null;
    }

    onCtaClicked(callback) {
        this.onCtaClickedCallback = callback;
    }

    show() {
        let temp = document.createElement('div');
        temp.innerHTML = this.template;
        let div = temp.querySelector('.slate');
        this.me = this.parentContainer.appendChild(div);

        for (let cta of this.me.querySelectorAll('.slate__cta .button')) {
            cta.addEventListener('click', () => {
                this.onCtaClickedCallback(cta);
            });
        }
    }

    close() {
        this.parentContainer.removeChild(this.me);
    }
}
